import { Collapse, TableCell, TableRow } from '@material-ui/core';
import 'moment/min/locales';
import React, { useEffect, useState } from 'react';
import Security from '../../commons/security/Security.js';
import Timezone from '../../commons/timezone/Timezone.js';
import { StyledTableCell, StyledTooltip } from '../../commons/utils/TableStyles';
import Fade from "@material-ui/core/Fade";
import SafeFeedbackFormularioModalAccion from './SafeFeedbackFormularioModalAccion.jsx';
import SafeFeedbackFormularioModalView from './SafeFeedbackFormularioModalView.jsx';
import Modal from "@material-ui/core/Modal";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import * as Utils from '../../commons/utils/Utils';
import LocaleFormat from '../../commons/utils/LocaleFormat.js';

const SafeFeedbackFormularioGridRow = (props) => {
	const intl = props.intl
	const formulario = props.formulario;
	const loading = props.loading;
	const [showModalAccion, setShowModalAccion] = useState(false);
	const [showModalView, setShowModalView] = useState(false);
	const [accion, setAccion] = useState(null);
	const [mostrarBase, setMostrarBase] = useState(false);

	const useStyles = makeStyles((theme) => ({
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			borderRadius: "15px",
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			border: "0px solid #000",
			boxShadow: theme.shadows[5],
			padding: theme.spacing(2, 4, 3),
			borderRadius: "15px",
			width: "600px",
		},
	}));
	
	useEffect(() => {
		if(formulario.safe_feedback_tipo_formulario.administracion_de_atributos_json){
			let administracion_de_atributos_json = JSON.parse(formulario.safe_feedback_tipo_formulario.administracion_de_atributos_json);
			if(administracion_de_atributos_json.includes("base")){
				setMostrarBase(true);
			}
		}
	}, []);

	const classes = useStyles();

	const openModalAccion = (accion) => {
		setAccion(accion)
		setShowModalAccion(true);
	};

	const closeModalAccion = () => {
		setAccion(null);
		setShowModalAccion(false);
	};

	const handleConfirmar = (comentario) => {
		props.setLoading(true);
		Utils.sendData(`/safe-feedback-formularios/${formulario.id}/accion`, 'PATCH', { comentario, accion: 'confirmar' })
		.then(() => {
		  	props.reloadData();
		})
		.finally(() => {
			setAccion(null)
			props.setLoading(false);
		});
	};
	
	const handleDesestimar = (comentario) => {
		props.setLoading(true);
		Utils.sendData(`/safe-feedback-formularios/${formulario.id}/accion`, 'PATCH', { comentario, accion: 'desestimar' })
		.then(() => {
			props.reloadData();
		})
		.finally(() => {
			setAccion(null)
			props.setLoading(false);
		});
	};

	return (
		<>
			<Modal
				open={showModalAccion}
				onClose={closeModalAccion}
				className={classes.modal}
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={showModalAccion}>
					<div className={classes.paper}>
						<SafeFeedbackFormularioModalAccion
							reporte={formulario}
							accion={accion}
							onClose={closeModalAccion}
							onConfirm={handleConfirmar}
							onDesestimar={handleDesestimar}
							loading={loading}
							mostrarBase={mostrarBase}
						/>
					</div>
				</Fade>
			</Modal>
			<Modal
				open={showModalView}
				onClose={() => setShowModalView(false)}
				className={classes.modal}
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={showModalView}>
					<div className={classes.paper}>
					<SafeFeedbackFormularioModalView
						reporte={formulario}
						onClose={() => setShowModalView(false)}
						loading={loading}
						mostrarBase={mostrarBase}
					/>
					</div>
				</Fade>
			</Modal>
			<TableRow>
				<StyledTableCell align="left">{formulario.id}</StyledTableCell>
				<StyledTableCell align="left">{formulario.safe_feedback_tipo_formulario.nombre}</StyledTableCell>
				<StyledTableCell align="left">
					{formulario.fecha_hora
						? LocaleFormat.formatDateTime(Timezone.getDateForClient(formulario.fecha_hora))
						: ''}
				</StyledTableCell>
				<StyledTableCell align="left">
					{formulario.base ? formulario.base.descripcion : ''}
				</StyledTableCell>
				<StyledTableCell align="left">{formulario.dominio}</StyledTableCell>
				<StyledTableCell align="left">
					{formulario.transportadora ? formulario.transportadora.nombre : '-'}
				</StyledTableCell>
				<StyledTableCell align="left">
					{formulario.centro_costos ? formulario.centro_costos.nombre : '-'}
				</StyledTableCell>
				<StyledTableCell align="left">
					<div className="d-inline-flex">
						{formulario.estado === "PENDIENTE" && Security.hasPermission('SAFEFEEDBACK_GESTIONAR_REPORTES') ? (
							<>
								<button
									className="action approve btn btn-sm btn-icon btn-dt-grid text-success"
									data-title={intl.formatMessage({ id: "SafeFeedbackFormularioGridRow.render.Confirmar", defaultMessage: "Confirmar" })}
									data-toggle="tooltip"
									data-placement="top"
									onClick={() => openModalAccion('confirmar')}
								>
								<i className="fas fa-check-circle fa-xs"></i>
								</button>
								<button
									className="action approve btn btn-sm btn-icon btn-dt-grid text-success"
									data-title={intl.formatMessage({ id: "SafeFeedbackFormularioGridRow.render.Desestimar", defaultMessage: "Desestimar" })}
									data-toggle="tooltip"
									data-placement="top"
									onClick={() => openModalAccion('desestimar')}
								>
									<i className="fas fa-times-circle fa-xs" style={{color: "red"}}></i>
								</button>
							</>
						) : ''}
						<button
							className="action view btn btn-sm btn-icon btn-dt-grid text-success"
							data-title={intl.formatMessage({ id: "SafeFeedbackFormularioGridRow.render.Ver", defaultMessage: "Ver" })}
							data-togle="tooltip"
							data-placement="top"
							onClick={() => setShowModalView(true)}
						>
							<i className="fa fa-search fa-xs" />
						</button>
						{formulario.estado !== "PENDIENTE" && Security.hasPermission('SAFEFEEDBACK_LISTAR') &&
							<button
								className="action btn btn-sm btn-icon btn-dt-grid text-success"
								data-title={intl.formatMessage({ id: "SafeFeedbackFormularioGridRow.render.Historico", defaultMessage: "Histórico de acciones" })}
								data-toggle="tooltip"
								data-placement="top"
								onClick={() => props.onVerHistorico(formulario)}
							>
								<i className="fa fa-history fa-xs" />
							</button>
						}
					</div>
				</StyledTableCell>
			</TableRow>
			<TableRow className="hidden-personal">
				<TableCell
					style={{ paddingBottom: 0, paddingTop: 0, background: 'rgb(244, 245, 250)' }}
					colSpan={19}
				>
				<Collapse in={false} timeout="auto" unmountOnExit>
					
				</Collapse>
				</TableCell>
			</TableRow>
		</>
	);
};

export default SafeFeedbackFormularioGridRow;
